import React, { useEffect } from "react";
import aboutUsImg from "../assets/WebImage/aboutus.jpg";
import { Link } from "react-router-dom";

function AboutUs() {
  const today = new Date();

  useEffect(() => {
    document.title = "Free Credit - About Us";
  }, []);

  return (
    <>
      <div className="card m-2">
        <div style={{ textAlign: "justify" }}>
          {" "}
          <div>
            <img
              style={{ maxWidth: "100%", height: "auto", display: "block" }}
              loading="lazy"
              src={aboutUsImg}
              alt="About Us-Jom Free Credit Malaysia"
            />
          </div>
          <div className="p-3">
            <h1>About Us</h1>
            <h2>About Jom Free Creedit</h2>
            <p>Who We Are</p>
            <p>
              JomFreeCredit.online is an independent Malaysian affiliate media
              platform dedicated to publishing verified free credit and
              no-deposit casino promotions.
            </p>
            <p>
              Operated by the New Register Free Editorial Team, our platform
              serves as an informational bridge between players and reputable
              gaming partners. We specialize in reviewing, organizing, and
              updating promotional offers to help users make informed decisions.
            </p>
            <p>
              JomFreeCredit.online is <strong>not</strong> a casino operator.
            </p>
            <ul>
              <li>We do not accept deposits.</li>
              <li>We do not manage gaming accounts.</li>
              <li>We do not process bets or payouts.</li>
            </ul>
            Our role is strictly informational and affiliate-based.
            <br />
            <hr />
            <h2>Our Mission</h2>
            <p>Our mission is to provide Malaysian players with:</p>
            <ul>
              <li>Transparent and verified free credit listings</li>
              <li>Regularly updated promotional information</li>
              <li>Clear explanations of bonus terms and eligibility</li>
              <li>Trusted partnership disclosures</li>
              <li>Responsible gaming guidance</li>
            </ul>
            <p>
              We aim to establish JomFreeCredit.online as a long-term authority
              platform for free credit promotions in Malaysia.
            </p>
            <hr />
            <h2>Editorial Standards & Verification Process</h2>
            <p>
              Accuracy and transparency are core principles of our operations.
              Before publishing or updating any promotion, our editorial team
              conducts a review process that may include:
            </p>
            <ul>
              <li>Partner verification</li>
              <li>Confirmation of promotional terms</li>
              <li>Eligibility validation</li>
              <li>Expiry date checks</li>
              <li>Ongoing update monitoring</li>
            </ul>
            <p>
              We prioritize factual clarity over exaggerated claims. When
              promotional terms change, we update our content accordingly to
              reflect accurate information.
            </p>
            <hr />
            <h2>Our Team</h2>
            <p>
              The JomFreeCredit Editorial Team, led by James and Anna, oversees
              all content development and partnership coordination.
            </p>
            <hr />
            <p>Our team is responsible for:</p>
            <ul>
              <li>Reviewing promotional details</li>
              <li>Ensuring clear presentation of terms</li>
              <li>Monitoring changes to partner offers</li>
              <li>Maintaining editorial consistency</li>
              <li>Upholding responsible gaming standards</li>
            </ul>
            <p>
              We operate under structured editorial guidelines to ensure
              fairness and transparency in all published content.
            </p>
            <hr />
            <h2>Our Partnerships</h2>
            We collaborate with established Malaysian gaming groups, including:
            <br />
            <br />
            <ul>
              <li>RM Group</li>
              <li>SCRPLAY</li>
              <li>Squeen668</li>
              <li>Syabas99</li>
              <li>Berjayasama</li>
              <li>Syukur668</li>
              <li>MBI8</li>
              <li>99Group</li>
              <li>DoktorJudi</li>
              <li>Menang Group</li>
              <li>4D Gang</li>
            </ul>
            Our partnerships are structured on an affiliate basis. We may
            receive commissions when users register through approved referral
            links.
            <br />
            <br />A full directory of partners is available on our
            <Link to="/partnerships" style={{ textDecoration: "none" }}>
              {" "}
              Partnerships page
            </Link>
            .
            <br />
            <hr />
            <h2>Trust & Responsibility</h2>
            JomFreeCredit.online operates under the following principles:
            <br />
            <br />
            <ul>
              <li>We publish verified promotional information only.</li>
              <li>We clearly disclose our affiliate relationships.</li>
              <li>We do not guarantee winnings or outcomes.</li>
              <li>We encourage responsible, entertainment-based gaming.</li>
              <li>We maintain updated and transparent listings.</li>
              <li>We provide informational content, not gambling services.</li>
            </ul>
            Our goal is to help users identify legitimate promotional platforms
            while promoting informed and responsible decision-making.
            <br />
            <hr />
            <h2>Privacy Policy</h2>
            <strong>Effective Date: </strong>1 April 2026
            <br />
            <strong>Last Updated: </strong>
            {today.toLocaleDateString("en-MY", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            <br />
            <br />
            This Privacy Policy explains how JomFreeCredit.online collects,
            uses, and protects personal information.
            <br />
            <hr />
            <h2>Information We Collect</h2>
            We may collect:
            <br />
            <br />
            Personal Information
            <br />
            <br />
            <ul>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Telegram ID</li>
              <li>Information voluntarily submitted through forms</li>
            </ul>{" "}
            Non-Personal Information
            <br />
            <br />
            <ul>
              <li>IP address</li>
              <li>Device type</li>
              <li>Browser type</li>
              <li>Usage data</li>
              <li>Cookies and analytics information</li>
            </ul>{" "}
            How We Use Information
            <br />
            <br />
            Collected information may be used to:
            <br />
            <br />
            <ul>
              <li>Respond to user inquiries</li>
              <li>Verify promotional claims</li>
              <li>Improve website performance and usability</li>
              <li>Communicate relevant updates</li>
              <li>Maintain security and prevent misuse</li>
            </ul>
            <hr />
            <h3>Cookies & Tracking</h3>
            We use cookies and analytics tools to:
            <br />
            <br />
            <ul>
              <li>Analyze website traffic</li>
              <li>Improve user experience</li>
              <li>Optimize content performance</li>
            </ul>
            Users may disable cookies through browser settings, though some
            functionality may be affected.
            <hr />
            <h3>Data Sharing</h3>
            We <strong>do not</strong> sell personal data.
            <br />
            <br />
            <p>
              Information may be shared with trusted affiliate partners solely
              for promotional verification purposes when necessary.
            </p>
            <hr />
            <h3>Data Security</h3>
            <p>
              We implement reasonable technical and organizational measures to
              protect user data. However, no digital transmission method is
              completely secure.
            </p>
            <hr />
            <h2>Terms & Conditions</h2>
            <h3>Introduction</h3>
            By accessing or using JomFreeCredit.online, you agree to comply with
            these Terms and Conditions.
            <hr />
            <h3>Our Role</h3>
            <p>JomFreeCredit.online is an affiliate information platform.</p>
            <p>We do not operate casinos or provide gambling services.</p>
            <p>
              All promotional offers displayed on this website are provided by
              third-party partners and are subject to their respective terms and
              conditions.
            </p>
            <hr />
            <h3>Eligibility</h3>
            <p>Users must :</p>
            <ul>
              <li>Be at least 18 years old</li>
              <li>Comply with applicable local laws</li>
              <li>
                Review and accept partner-specific terms before registering
              </li>
            </ul>
            <hr />
            <h3>Limitation of Liability</h3>
            <p>JomFreeCredit.online :</p>
            <ul>
              <li>Does not guarantee winnings</li>
              <li>Is not responsible for third-party platform operations</li>
              <li>Is not liable for changes in partner promotions</li>
              <li>Is not responsible for account-related disputes</li>
            </ul>
            <p>Users engage with partner platforms at their own discretion.</p>
            <hr />
            <h3>Updates</h3>
            <p>
              We reserve the right to update these Terms at any time without
              prior notice. Continued use of the website constitutes acceptance
              of revised terms.
            </p>
            <hr />
            <h1 style={{ textAlign: "left" }}>RESPONSIBLE GAMING DISCLAIMER</h1>
            <p>
              JomFreeCredit.online promotes free credit offers as a form of
              entertainment-based online gaming.
            </p>
            <p>We encourage users to:</p>
            <ul>
              <li>Set personal limits</li>
              <li>Avoid gambling as a source of income</li>
              <li>Take breaks when necessary</li>
              <li>Seek assistance if gaming becomes problematic</li>
            </ul>
            <p>
              If you believe your gambling behavior may be harmful, consider
              contacting professional support organizations or local assistance
              services.
            </p>
            <p>
              We are committed to promoting responsible and informed gaming
              practices.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default AboutUs;
